import styled from '@emotion/styled';
import { primaryFontFamily } from '../../styles/fonts';

type ContainerProps = {
  size: 'small' | 'big';
};

export const Container = styled.span<ContainerProps>`
  ${primaryFontFamily}
  font-size: ${({ size = 'small' }) => (size === 'small' ? 14 : 20)}px;
  line-height: ${({ size = 'small' }) => (size === 'small' ? 20 : 28)}px;
  font-weight: 400;
  color: ${({ theme }) => theme.default.colors.n4};
  padding-right: ${({ size = 'small' }) => (size === 'small' ? 0 : 8)}px;
`;
